import { Component, OnInit, ViewChild } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { normalizarValorOrdenacao } from '../../../shared/helpers/ordenacao-tabela.helper';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PerfilService } from '../../../shared/services/apis/usuario/perfil.service';
import { ListaPerfilResponse } from '../../../shared/services/responses/usuario/lista-perfil.response';
import { ListaPerfilStruct } from '../../../shared/services/structs/usuario/lista-perfil.struct';
import { MatMenuModule } from '@angular/material/menu';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { UtilService } from '../../../shared/services/util.service';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';

@Component({
  selector: 'app-perfil-lista',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatMenuModule,
    MatSortModule,
    HeaderComponent,
    LoadingBoxDefaultListComponent,
  ],
  templateUrl: './perfil-lista.component.html',
  styleUrl: './perfil-lista.component.css',
})
export class PerfilListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this._dataSource.sort = sort;
    this._dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'nomePerfil':
          return normalizarValorOrdenacao(item.perfil.nome);
        case 'idPerfil':
          return normalizarValorOrdenacao(item.perfil.idPerfil);
        default:
          return normalizarValorOrdenacao((item as any)[property]);
      }
    };
  }

  constructor(
    private formBuilder: FormBuilder,
    private perfilService: PerfilService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private utilService: UtilService
  ) {
    this.moduloEnum = ModuloEnum.Configuracoes;
    this.funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Perfil;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaPerfilResponse: ListaPerfilResponse | undefined;
  public displayedColumns: string[] = ['idPerfil', 'nomePerfil', 'descricao', 'restricoes', 'actions'];
  public _dataSource = new MatTableDataSource<ListaPerfilStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      pesquisa: [''],
    });

    this.loadFilters();
    this.pesquisar();
  }

  ngOnDestroy(): void {
    this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, [
      '/configuracoes/perfil/cadastrar',
    ]);
  }

  private loadFilters() {
    const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
    if (filtroSalvo) {
      this.model.patchValue(filtroSalvo);
    }
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading == true) {
      return;
    }

    this._isLoading = true;
    const pesquisa: string = this.model.get('pesquisa')?.value;

    this.perfilService.get(pesquisa, this._paginaAtual).subscribe({
      next: (response: ListaPerfilResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;

        if (!this._listaPerfilResponse) {
          this._listaPerfilResponse = response;
          this._ultimaPagina = false;
        } else if (response.listaPerfil?.length > 0) {
          this._listaPerfilResponse.listaPerfil.push(...response.listaPerfil);
          this._ultimaPagina = false;
        }

        this._dataSource.data = this._listaPerfilResponse.listaPerfil;
      },
      error: error => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaPerfilResponse = undefined;
    this.pesquisar();
  }

  abrirModalExcluir(idPerfil: number, nomePerfil: string): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Alerta',
        description: `Deseja excluir o perfil ${nomePerfil}? Essa ação será irreversível.`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.excluir(idPerfil);
        }
      },
    });
  }

  private excluir(idPerfil: number): void {
    this.perfilService.excluir(idPerfil).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.clickPesquisar();

        this.alertService.show('Sucesso', 'Perfil excluido com sucesso', AlertType.success);
      },
      error: error => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }
}
